export default "__VITE_ASSET__DxMKMvWK__"